import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { isMobilePersonalRegisterURL } from "@/utils/isRegisterURL";
import { useImmerAtom } from "jotai-immer";
import { settingsPersonalAtom } from "../../state";

type SaveToReduxProps = {
  fieldName: keyof ReturnType<(typeof settingsPersonalAtom)["read"]>["mobileFormEdit"];
  fieldValue: any;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  nextUrlForMobileRegisterURL: string;
};

export function useSaveToRedux() {
  const isRegisterURL = isMobilePersonalRegisterURL();
  const [, setSettingsPersonalState] = useImmerAtom(settingsPersonalAtom);

  const navigate = useNavigate();
  const { settings } = DashboardRoutes;

  const saveToRedux = async ({
    nextUrlForMobileRegisterURL,
    fieldName,
    fieldValue,
    setIsDrawerOpen,
  }: SaveToReduxProps) => {
    setSettingsPersonalState((draft) => {
      draft.mobileFormEdit[fieldName] = fieldValue;
    });
    setIsDrawerOpen(false);

    if (isRegisterURL) {
      navigate(nextUrlForMobileRegisterURL);
    } else {
      navigate(settings.personal.root.url);
    }
  };

  return { saveToRedux };
}
